import React, { useState } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import packageJson from '../../../../../../package.json';
import { useAuth } from "../../../../../providers/AuthContext.tsx";
import { AccountStrings } from "../../../business/core";
import { FormPasswordControllerImpl } from "../../../business/impl/controllers/FormPasswordControllerImpl.ts";

export const FormPasswordComponent = ({ setStep, step }) => {
  const navigate = useNavigate();
  const { phone, handleLogin, callbackLogin } = useAuth();
  const [password, setPassword] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);
  const [callback, setCallback] = useState<string | null>("");
  const [passwordError, setPasswordError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const controller = new FormPasswordControllerImpl();
  const version = packageJson.version;

  const strings = AccountStrings['PTBR'].login;

  const handlePasswordSubmit = async (event) => {
    event.preventDefault(); // Previne o envio do formulário
    setIsLoading(true);
    setPasswordError(false);

    if (password === "") {
      setCallback("Informe sua senha");
      setPasswordError(true);
      setIsLoading(false);
      return false;
    }

    const loginResponse = await controller.tryLogin(
      btoa(`${phone}:${password}`)
    );

    if (loginResponse.success) {
      await handleLogin(loginResponse.response);
      setTimeout(() => {
        if (callbackLogin.goBack) {
          navigate(callbackLogin.origin, { state: callbackLogin.params });
          return true;
        }
        navigate('/home');
        return true;
      }, 1000);
    } else {
      setCallback(loginResponse.response);
      setPasswordError(true);
      setIsLoading(false);
    }
  };

  // // Prevenir envio do formulário ao pressionar Enter
  // const handleKeyDown = (event) => {
  //   if (event.key === "Enter") {
  //     event.preventDefault(); // Impede o envio do formulário com Enter
  //   }
  // };

  return (
    <>
      <p className="mb-4 text-center">{strings.subtitle[step]}</p>
      <Form
        noValidate
        className="mt-4"
        onSubmit={handlePasswordSubmit}
      // onKeyDown={handleKeyDown} // Captura o Enter e impede o envio
      >
        <Form.Group className="mb-3" controlId="formBasicPassword">
          <InputGroup hasValidation>
            <Form.Control
              type={showPassword ? 'text' : 'password'}
              required
              placeholder={strings.passwordPlaceholder}
              onChange={(e) => setPassword(e.target.value)}
              className="custom-input"
              isInvalid={passwordError}
              disabled={isLoading}
              autoFocus
            />
            <Button variant="outline-secondary"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </Button>
            <Form.Control.Feedback type="invalid">
              {passwordError ? callback : ""}
            </Form.Control.Feedback>
          </InputGroup>
          <p className="mb-4 mt-2">
            <a href="#" className="linkBold" onClick={() => navigate("/recovery-access")}>
              {strings.forgotPassword}
            </a>
          </p>
        </Form.Group>
        <div className="row">
          <div className="col">
            <Button
              variant="secondary"
              type="button"
              className="px-4 button-flat"
              active
              onClick={() => setStep(1)}
              disabled={isLoading}
            >
              {strings.buttonBack}
            </Button>
          </div>
          <div className="col d-flex flex-row-reverse">
            <Button
              variant="primary"
              type="submit"
              className="px-4 button-flat"
              disabled={isLoading}
            >
              {!isLoading ? (
                strings.buttonNext
              ) : (
                <Spinner animation="border" size="sm" role="status">
                  <span className="visually-hidden">...</span>
                </Spinner>
              )}
            </Button>
          </div>
        </div>
        <Row>
          <Col className="text-center mt-2"><small style={{ color: '#999999' }}>v{version}</small></Col>
        </Row>
      </Form>
    </>
  );
};
